import { useEffect, useState } from "react";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { GoDotFill } from "react-icons/go";
import { IProject } from "../../../../../../../libs/types/projects";
import DataFunctions from "../../../../functions/database";
import useBoardsSocket from "../../../../hooks/useBoardsSocket";
import useProjectsSocket from "../../../../hooks/useProjectsSocket";
import useSensorValuesSocket from "../../../../hooks/useSensorValuesSocket";
import useSensorsSocket from "../../../../hooks/useSensorsSocket";
import moment from "../../../../utils/moment";
import NoData from "../../../noData";
import "../../styles.css";

interface IProps {
  viewMaster: boolean;
  idUser: string;
}

const DashProject: React.FC<IProps> = ({ viewMaster, idUser }) => {
  const useProjects = useProjectsSocket();
  const useBoards = useBoardsSocket();
  const useSensors = useSensorsSocket();
  const useValues = useSensorValuesSocket();

  const [projects, setProjects] = useState<IProject[]>([]);

  useEffect(() => {
    if (viewMaster) {
      setProjects(useProjects);
    } else {
      setProjects(
        useProjects.filter((val) => new DataFunctions().getId(val) === idUser)
      );
    }
  }, [useProjects, viewMaster]);

  return (
    <div>
      {projects.length > 0 ? (
        <Table className="mt-3" striped bordered hover size="sm" variant="dark">
          <thead>
            <tr>
              <th className="text-center ">Nome</th>
              <th className="text-center">Endereço</th>
              <th className="text-center">Placas</th>
              <th className="text-center">Sensores</th>
              <th className="text-center">Dados Coletados</th>
              <th className="text-center">Usuários Vinculados</th>
              <th className="text-center">Última Atualização</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((item) => {
              return (
                <tr key={new DataFunctions().getId(item)}>
                  <td className="text-center col-md-1 align-middle">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>
                          Projeto{" "}
                          <strong>{item.active ? "Ativo" : "Inativo"}</strong>
                        </Tooltip>
                      }
                    >
                      <div>
                        {item.name.toUpperCase()}{" "}
                        <GoDotFill
                          size={20}
                          color={item.active ? "green" : "red"}
                        />
                      </div>
                    </OverlayTrigger>
                  </td>

                  <td className="text-center col-md-1 align-middle">
                    {new DataFunctions().getAddress(item.address)}
                  </td>

                  <td className="text-center col-md-1 align-middle">
                    {
                      useBoards.filter(
                        (val) =>
                          new DataFunctions().getId(val.project) ===
                          new DataFunctions().getId(item)
                      ).length
                    }
                  </td>

                  <td className="text-center col-md-1 align-middle">
                    {
                      useSensors.filter(
                        (val) =>
                          new DataFunctions().getId(val.board.project) ===
                          new DataFunctions().getId(item)
                      ).length
                    }
                  </td>

                  <td className="text-center col-md-1 align-middle">
                    {
                      useValues.filter(
                        (val) =>
                          new DataFunctions().getId(
                            val.sensor.board.project
                          ) === new DataFunctions().getId(item)
                      ).length
                    }
                  </td>

                  <td className="text-center col-md-1 align-middle">
                    {item.users.length}
                  </td>

                  <td className="text-center col-md-1 align-middle">
                    {moment(item.modifiedAt).format("DD/MM/YYYY [às] HH:mm:ss")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <NoData size={50} />
      )}
    </div>
  );
};

export default DashProject;
